/*
 * Module for the Member Account Balance report criteria page
 */
rs.module("content/reports/criteria/memberaccountbalancecriteria",

    ["common/visibility"],

    function (visibility) {

        // Initialize the page
        function initialize(jsSelectors, modes) {

            var criteria = $.js(jsSelectors.criteria);

            var modeSelect = criteria.js(jsSelectors.modeSelect);
            var searchContainer = criteria.js(jsSelectors.searchContainer);
            var statusContainer = criteria.js(jsSelectors.statusContainer);

            // Register modeSelect changed event
            modeSelect.change(modeChanged);

            // On mode change, handle display of control containers
            function modeChanged() {

                var selectedMode = modeSelect.val();

                if (selectedMode == modes.group) {
                    visibility.hide(searchContainer);
                    visibility.show(statusContainer);
                }
                else {
                    visibility.show(searchContainer);
                    visibility.hide(statusContainer);
                }
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);